module.exports = __webpack_public_path__ + "img/06.b7728e9e.png";